import { Gauge, KanbanSquare, LayoutGrid, List, Table2 } from 'lucide-react';
import type { OpcionDeVista } from '@/components/ui/SelectorDeVista';
import type { PrefCartera } from '@/lib/pref-cartera';

/** Las cuatro maneras de ver «Clientes» y, de quinta, la salud de cada fuente (T14), con su icono: las usan el selector de la barra y «Mis vistas». */
export const VISTAS: OpcionDeVista<PrefCartera['vista']>[] = [
  { id: 'tabla', etiqueta: 'Tabla', icono: Table2, ayuda: 'En grupos, y cada dato se cambia en su celda' },
  { id: 'kanban', etiqueta: 'Kanban', icono: KanbanSquare, ayuda: 'Una columna por etapa: arrastra para moverlos' },
  { id: 'tarjetas', etiqueta: 'Tarjetas', icono: LayoutGrid, ayuda: 'Cada cliente con su línea de progreso' },
  { id: 'lista', etiqueta: 'Lista', icono: List, ayuda: 'De la A a la Z' },
  { id: 'fuentes', etiqueta: 'Fuentes', icono: Gauge, ayuda: 'De qué base vienen tus clientes y cuál rinde más' },
];
